import { actionTypes, errorTypes, getterTypes } from '@/types';

export default function setArticleByCode({ getters, dispatch, state }, { code }) {
	if (typeof code !== 'number') {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.pleaseEnterACode) });
		return;
	}
	const article = getters[getterTypes.articleCodeMap][code];
	if (!article) {
		dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownCode) });
		return;
	}
	if (
		state.tour.active &&
		state.tour.current.exhibitIDs.find(({ articleID }) => articleID === article.articleID)
	) {
		dispatch(actionTypes.pushUrl, {
			url: `/${article.exhibitionID}/tour/${state.tour.current.id}/${article.articleID}`,
			replace: false,
		});
	} else {
		dispatch(actionTypes.pushUrl, {
			url: `/${article.exhibitionID}/${article.articleID}`,
			replace: false,
		});
	}
	// if (closeModal) commit(mutationTypes.setViewstate, { viewState: VIEW_STATE.content });
}
